import { EnterpriseRole } from '@/api/generated'
import { SelectOption } from '@/components/Select'
import { Role } from '@/types'

// Human-friendly labels for enterprise roles. `Object.entries(EnterpriseRole)`
// would yield the PascalCase enum key (e.g. "ItAdmin"), which is not a valid
// display string.
export const ROLE_LABELS: Record<Role, string> = {
  member: 'Member',
  admin: 'Admin',
  superadmin: 'Superadmin',
  // eslint-disable-next-line camelcase
  it_admin: 'IT Admin',
}

// Derive options from generated EnterpriseRole enum
export const ENTERPRISE_ROLE_OPTIONS: SelectOption[] = Object.values(EnterpriseRole).map((value) => ({
  value,
  label: ROLE_LABELS[value as Role],
}))

// Assignable roles only (excludes superadmin, which is not assignable via UI)
export const ASSIGNABLE_ROLE_OPTIONS: SelectOption[] = ENTERPRISE_ROLE_OPTIONS.filter(
  (option) => option.value !== EnterpriseRole.Superadmin
)

export const DOMAIN_CAPTURE_DOCS_URL =
  'https://docs.wisprflow.ai/articles/3897289456-verify-your-domain-for-sso'
